<template>
    <page :loading="loading">
        <div slot="header" class="flex-row">
			<div class="flex-item page_header">
				<el-form size="small" :inline="true">
					<el-form-item>
						<el-button @click="table.form = {sort: 0, status: 1},showDialog = true" type="primary" plain>添加保险分类</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

        <page-table rowkey="id" :treeprops="{ children: 'children', hasChildren: 'hasChildren' }" :datas="table.data" :page="table.search.page" :size="table.search.size" :total="table.count" @change="LoadDatas">
			<el-table-column prop='id'   label='ID'       header-align="left" align='left'/>
			<el-table-column prop='name' label='分类名称'  header-align="left" align='left'/>
			<el-table-column label="图标" align="center" width="300">
				<template slot-scope="scope">
					<el-image v-if="scope.row.image" style="width: 50px; height: 50px" :src="$img(scope.row.image)" :preview-src-list="[$img(scope.row.image)]"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop='sort' label='排序' align='center' width="200"/>
			<el-table-column label="状态" align="center" width="260">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.status">显示</el-tag>
					<el-tag v-else type="danger">隐藏</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop='created_at' label='创建时间' align='center' width="200"/>
            <el-table-column label="操作" align="center" fixed="right" width="220">
                <template slot-scope="scope">
					<el-button @click="table.form = scope.row, showDialog = true" type="text" size="small">修改</el-button>
                    <el-button v-if="scope.row.pid == 0" @click="table.form = {sort: 0, status: 1, pid: scope.row.id}, scope.row,showDialog = true" type="text" size="small">新增</el-button>
                    <el-button @click="ActionDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </page-table>

        <el-dialog :modal="false" title="保险分类" :visible.sync="showDialog" width="35%">
			<el-form label-width="100px">
				<el-form-item label="上级分类">
				    <el-select v-model="table.form.pid" placeholder="请选择上级分类" clearable :disabled="table.form.id && !table.form.pid ? true : false">
						<el-option label="请选择" :value="0"></el-option>
						<el-option v-for="(item,index) in mainMenuList" :key="index" :label="item.name" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="分类名称">
					<el-input v-model="table.form.name" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="分类图标">
					<page-images v-model="table.form.image" :limit="1" />
				</el-form-item>
				<el-form-item label="显示排序">
					<el-input-number :min="0" v-model="table.form.sort" size="mini"></el-input-number>
				</el-form-item>
				<el-form-item label="显示状态">
					<el-switch v-model="table.form.status" :active-value="1" :inactive-value="0" active-color="#188fff" inactive-color="#e5e5e5"></el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="ActionSave(table.form)">保存</el-button>
					<el-button @click="showDialog = false, table.form = {}">取消</el-button>
				</el-form-item>
			</el-form>
        </el-dialog>
    </page>
</template>
<script>
export default {
    data(){
        return {
			showDialog: false,
            loading: false,
            table:{
                data: [],
                form: {},
                search: {
                    _page: 1,
                    _size: 20,
                },
            	_count:0,
            },
			mainMenuList: [],
        }
    },
    mounted() {
		this.LoadDatas();
		this.selectMainMenu();
    },
    methods: {
		//查询一级菜单栏
		selectMainMenu(){
			this.$get('app-goods-category',{pid: 0, _order: 'sort'}).then(res=>{  
				this.mainMenuList = res.data;
			}).catch(err=>{
			    this.$warning(err);
			});
		},
        LoadDatas(){
			this.loading = true;
            this.$get('treeCategoryList').then(res=>
            {   
                this.table.data = res.data, this.loading = false;
            }).catch(err=>
            {
				this.$warning(err), this.loading = false;
            });
        },
        /**
         * 保存
         * @param item 要保存的数据
         * **/
        ActionSave(item){
			if( !item.name ){
				return this.$warning('请输入分类名称');
			}
            this.loading = true;
            this.$save('app-goods-category',item).then(res=>
            {
				this.selectMainMenu();
                this.loading = false, this.LoadDatas(), this.$success('操作成功'), this.showDialog = false;
            }).catch(err=>
            {
                this.loading = false, this.$warning(err);
            });
        },
        /**
         * 删除
         * @param item 要删除的数据
         * **/
        ActionDel(item){
            if( item.id ){
                this.loading = true;
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                    this.$del('app-goods-category/'+item.id).then(res=>{
                        this.loading = false , this.LoadDatas() , this.$success('操作成功');
                    }).catch(err=>{
                        this.loading = false , this.$warning(err);
                    })
                }).catch(()=>{
                    this.loading = false;
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
	::v-deep .el-table .cell:nth-child(1) {
		text-align: left;
	}
	
	.page_header {
		margin:10px 10px 0;
		position: absolute;
		z-index: 100;
	}
	
	.icon_list {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		text-align: center;
		overflow: auto;
		height: 640px;
		margin-top: -20px;
		.icon_item {
			margin-top: 30px;
			width: 33.3%;
			cursor: pointer;
			i {
				font-size: 40px;
			}
			div {
				font-size: 16px;
				margin-top: 20px;
				width: 120px;
				margin: 10px auto;
				height: 20px;
			}
		}
	}
</style>